export default __webpack_public_path__ + "static/media/smallColoredLogoBelobank.98cad902.svg";